//src/pages/FinanzasPage.jsx
import { useState, useEffect } from 'react';
import {
  Paper, Typography, Button, Stack, Tooltip, TextField, MenuItem, FormControl, InputLabel,
  Grid, Card, CardContent, Box, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Chip, Container, Dialog, DialogTitle, DialogContent,
  DialogActions, IconButton, Accordion, AccordionSummary, AccordionDetails,
  Autocomplete, Select, FormControlLabel, Switch, ToggleButtonGroup, ToggleButton, InputAdornment, Avatar 
} from '@mui/material';
import {
  Add as AddIcon, Download as DownloadIcon, TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon, AttachMoney as MoneyIcon, Close as CloseIcon,
  ExpandMore as ExpandMoreIcon, Info as InfoIcon, Category as CategoryIcon,
  Print as PrintIcon, Delete as DeleteIcon, Edit as EditIcon, Save as SaveIcon
} from '@mui/icons-material';
import { useTheme, alpha } from '@mui/material/styles';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import axiosInstance from '../axiosInstance';
import { toast } from 'react-toastify';
import logoImage from '../assets/tu_logo.png';
import { useAuth } from '../context/AuthContext';
import { useClinic } from '../context/ClinicContext';
import ClinicFinanzasPage from './Clinic/ClinicFinanzasPage';
import { motion } from 'framer-motion';


// Catálogo de monedas (sin cambios)
const currencies = [
  { code: 'AED', symbol: 'د.إ', name: 'Dirham de EAU' },
  { code: 'AFN', symbol: '؋', name: 'Afgani Afgano' },
  { code: 'ALL', symbol: 'L', name: 'Lek Albanés' },
  { code: 'AMD', symbol: '֏', name: 'Dram Armenio' },
  { code: 'ANG', symbol: 'ƒ', name: 'Florín Antillano Neerlandés' },
  { code: 'AOA', symbol: 'Kz', name: 'Kwanza Angoleño' },
  { code: 'ARS', symbol: '$', name: 'Peso Argentino' },
  { code: 'AUD', symbol: 'A$', name: 'Dólar Australiano' },
  { code: 'AWG', symbol: 'ƒ', name: 'Florín Arubeño' },
  { code: 'AZN', symbol: '₼', name: 'Manat Azerbaiyano' },
  { code: 'BAM', symbol: 'KM', name: 'Marco Convertible de Bosnia-Herzegovina' },
  { code: 'BBD', symbol: 'Bds$', name: 'Dólar de Barbados' },
  { code: 'BDT', symbol: '৳', name: 'Taka Bangladesí' },
  { code: 'BGN', symbol: 'лв', name: 'Lev Búlgaro' },
  { code: 'BHD', symbol: '.د.ب', name: 'Dinar Bareiní' },
  { code: 'BIF', symbol: 'FBu', name: 'Franco Burundés' },
  { code: 'BMD', symbol: 'BD$', name: 'Dólar Bermudeño' },
  { code: 'BND', symbol: 'B$', name: 'Dólar de Brunéi' },
  { code: 'BOB', symbol: 'Bs.', name: 'Boliviano' },
  { code: 'BRL', symbol: 'R$', name: 'Real Brasileño' },
  { code: 'BSD', symbol: 'B$', name: 'Dólar Bahameño' },
  { code: 'BTN', symbol: 'Nu.', name: 'Ngultrum Butanés' },
  { code: 'BWP', symbol: 'P', name: 'Pula Botsuanesa' },
  { code: 'BYN', symbol: 'Br', name: 'Rublo Bielorruso' },
  { code: 'BZD', symbol: 'BZ$', name: 'Dólar Beliceño' },
  { code: 'CAD', symbol: 'C$', name: 'Dólar Canadiense' },
  { code: 'CDF', symbol: 'FC', name: 'Franco Congoleño' },
  { code: 'CHF', symbol: 'Fr', name: 'Franco Suizo' },
  { code: 'CLP', symbol: '$', name: 'Peso Chileno' },
  { code: 'CNY', symbol: '¥', name: 'Yuan Chino' },
  { code: 'COP', symbol: '$', name: 'Peso Colombiano' },
  { code: 'CRC', symbol: '₡', name: 'Colón Costarricense' },
  { code: 'CUP', symbol: '₱', name: 'Peso Cubano' },
  { code: 'CVE', symbol: '$', name: 'Escudo Caboverdiano' },
  { code: 'CZK', symbol: 'Kč', name: 'Corona Checa' },
  { code: 'DJF', symbol: 'Fdj', name: 'Franco Yibutiano' },
  { code: 'DKK', symbol: 'kr', name: 'Corona Danesa' },
  { code: 'DOP', symbol: 'RD$', name: 'Peso Dominicano' },
  { code: 'DZD', symbol: 'د.ج', name: 'Dinar Argelino' },
  { code: 'EGP', symbol: 'E£', name: 'Libra Egipcia' },
  { code: 'ERN', symbol: 'Nfk', name: 'Nakfa Eritreo' },
  { code: 'ETB', symbol: 'Br', name: 'Birr Etíope' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'FJD', symbol: 'FJ$', name: 'Dólar Fiyiano' },
  { code: 'FKP', symbol: '£', name: 'Libra Malvinense' },
  { code: 'GBP', symbol: '£', name: 'Libra Esterlina' },
  { code: 'GEL', symbol: '₾', name: 'Lari Georgiano' },
  { code: 'GHS', symbol: 'GH₵', name: 'Cedi Ghanés' },
  { code: 'GIP', symbol: '£', name: 'Libra Gibraltareña' },
  { code: 'GMD', symbol: 'D', name: 'Dalasi Gambiano' },
  { code: 'GNF', symbol: 'FG', name: 'Franco Guineano' },
  { code: 'GTQ', symbol: 'Q', name: 'Quetzal Guatemalteco' },
  { code: 'GYD', symbol: 'G$', name: 'Dólar Guyanés' },
  { code: 'HKD', symbol: 'HK$', name: 'Dólar de Hong Kong' },
  { code: 'HNL', symbol: 'L', name: 'Lempira Hondureño' },
  { code: 'HRK', symbol: 'kn', name: 'Kuna Croata' },
  { code: 'HTG', symbol: 'G', name: 'Gourde Haitiano' },
  { code: 'HUF', symbol: 'Ft', name: 'Forinto Húngaro' },
  { code: 'IDR', symbol: 'Rp', name: 'Rupia Indonesia' },
  { code: 'ILS', symbol: '₪', name: 'Nuevo Séquel Israelí' },
  { code: 'INR', symbol: '₹', name: 'Rupia India' },
  { code: 'IQD', symbol: 'ع.د', name: 'Dinar Iraquí' },
  { code: 'IRR', symbol: '﷼', name: 'Rial Iraní' },
  { code: 'ISK', symbol: 'kr', name: 'Corona Islandesa' },
  { code: 'JMD', symbol: 'J$', name: 'Dólar Jamaiquino' },
  { code: 'JOD', symbol: 'د.ا', name: 'Dinar Jordano' },
  { code: 'JPY', symbol: '¥', name: 'Yen Japonés' },
  { code: 'KES', symbol: 'KSh', name: 'Chelín Keniano' },
  { code: 'KGS', symbol: 'с', name: 'Som Kirguís' },
  { code: 'KHR', symbol: '៛', name: 'Riel Camboyano' },
  { code: 'KMF', symbol: 'CF', name: 'Franco Comorense' },
  { code: 'KPW', symbol: '₩', name: 'Won Norcoreano' },
  { code: 'KRW', symbol: '₩', name: 'Won Surcoreano' },
  { code: 'KWD', symbol: 'د.ك', name: 'Dinar Kuwaití' },
  { code: 'KYD', symbol: 'CI$', name: 'Dólar de las Islas Caimán' },
  { code: 'KZT', symbol: '₸', name: 'Tenge Kazajo' },
  { code: 'LAK', symbol: '₭', name: 'Kip Laosiano' },
  { code: 'LBP', symbol: 'ل.ل', name: 'Libra Libanesa' },
  { code: 'LKR', symbol: 'Rs', name: 'Rupia de Sri Lanka' },
  { code: 'LRD', symbol: 'L$', name: 'Dólar Liberiano' },
  { code: 'LSL', symbol: 'M', name: 'Loti Lesotense' },
  { code: 'LYD', symbol: 'ل.د', name: 'Dinar Libio' },
  { code: 'MAD', symbol: 'د.م.', name: 'Dírham Marroquí' },
  { code: 'MDL', symbol: 'L', name: 'Leu Moldavo' },
  { code: 'MGA', symbol: 'Ar', name: 'Ariary Malgache' },
  { code: 'MKD', symbol: 'ден', name: 'Denar Macedonio' },
  { code: 'MMK', symbol: 'K', name: 'Kyat Birmano' },
  { code: 'MNT', symbol: '₮', name: 'Tugrik Mongol' },
  { code: 'MOP', symbol: 'MOP$', name: 'Pataca de Macao' },
  { code: 'MRU', symbol: 'UM', name: 'Uguiya Mauritano' },
  { code: 'MUR', symbol: '₨', name: 'Rupia Mauriciana' },
  { code: 'MVR', symbol: 'Rf', name: 'Rufiyaa Maldiva' },
  { code: 'MWK', symbol: 'MK', name: 'Kwacha Malauí' },
  { code: 'MXN', symbol: '$', name: 'Peso Mexicano' },
  { code: 'MYR', symbol: 'RM', name: 'Ringgit Malayo' },
  { code: 'MZN', symbol: 'MT', name: 'Metical Mozambiqueño' },
  { code: 'NAD', symbol: 'N$', name: 'Dólar Namibio' },
  { code: 'NGN', symbol: '₦', name: 'Naira Nigeriana' },
  { code: 'NIO', symbol: 'C$', name: 'Córdoba Nicaragüense' },
  { code: 'NOK', symbol: 'kr', name: 'Corona Noruega' },
  { code: 'NPR', symbol: '₨', name: 'Rupia Nepalí' },
  { code: 'NZD', symbol: 'NZ$', name: 'Dólar Neozelandés' },
  { code: 'OMR', symbol: 'ر.ع.', name: 'Rial Omaní' },
  { code: 'PAB', symbol: 'B/.', name: 'Balboa Panameño' },
  { code: 'PEN', symbol: 'S/.', name: 'Sol Peruano' },
  { code: 'PGK', symbol: 'K', name: 'Kina de Papúa Nueva Guinea' },
  { code: 'PHP', symbol: '₱', name: 'Peso Filipino' },
  { code: 'PKR', symbol: '₨', name: 'Rupia Pakistaní' },
  { code: 'PLN', symbol: 'zł', name: 'Złoty Polaco' },
  { code: 'PYG', symbol: '₲', name: 'Guaraní Paraguayo' },
  { code: 'QAR', symbol: 'ر.ق', name: 'Riyal Catarí' },
  { code: 'RON', symbol: 'lei', name: 'Leu Rumano' },
  { code: 'RSD', symbol: 'дин', name: 'Dinar Serbio' },
  { code: 'RUB', symbol: '₽', name: 'Rublo Ruso' },
  { code: 'RWF', symbol: 'FRw', name: 'Franco Ruandés' },
  { code: 'SAR', symbol: 'ر.س', name: 'Riyal Saudí' },
  { code: 'SBD', symbol: 'SI$', name: 'Dólar de las Islas Salomón' },
  { code: 'SCR', symbol: '₨', name: 'Rupia Seychelense' },
  { code: 'SDG', symbol: 'ج.س.', name: 'Libra Sudanesa' },
  { code: 'SEK', symbol: 'kr', name: 'Corona Sueca' },
  { code: 'SGD', symbol: 'S$', name: 'Dólar de Singapur' },
  { code: 'SHP', symbol: '£', name: 'Libra de Santa Elena' },
  { code: 'SLL', symbol: 'Le', name: 'Leone de Sierra Leona' },
  { code: 'SOS', symbol: 'S', name: 'Chelín Somalí' },
  { code: 'SRD', symbol: '$', name: 'Dólar Surinamés' },
  { code: 'SSP', symbol: '£', name: 'Libra Sursudanesa' },
  { code: 'STN', symbol: 'Db', name: 'Dobra de Santo Tomé y Príncipe' },
  { code: 'SYP', symbol: '£S', name: 'Libra Siria' },
  { code: 'SZL', symbol: 'E', name: 'Lilangeni Suazi' },
  { code: 'THB', symbol: '฿', name: 'Baht Tailandés' },
  { code: 'TJS', symbol: 'ЅМ', name: 'Somoni Tayiko' },
  { code: 'TMT', symbol: 'm', name: 'Manat Turcomano' },
  { code: 'TND', symbol: 'د.ت', name: 'Dinar Tunecino' },
  { code: 'TOP', symbol: 'T$', name: 'Paʻanga Tongano' },
  { code: 'TRY', symbol: '₺', name: 'Lira Turca' },
  { code: 'TTD', symbol: 'TT$', name: 'Dólar de Trinidad y Tobago' },
  { code: 'TWD', symbol: 'NT$', name: 'Nuevo Dólar Taiwanés' },
  { code: 'TZS', symbol: 'TSh', name: 'Chelín Tanzano' },
  { code: 'UAH', symbol: '₴', name: 'Grivna Ucraniana' },
  { code: 'UGX', symbol: 'USh', name: 'Chelín Ugandés' },
  { code: 'USD', symbol: '$', name: 'Dólar Estadounidense' },
  { code: 'UYU', symbol: '$U', name: 'Peso Uruguayo' },
  { code: 'UZS', symbol: 'лв', name: 'Som Uzbeko' },
  { code: 'VES', symbol: 'Bs.S', name: 'Bolívar Soberano Venezolano' },
  { code: 'VND', symbol: '₫', name: 'Đồng Vietnamita' },
  { code: 'VUV', symbol: 'VT', name: 'Vatu Vanuatuense' },
  { code: 'WST', symbol: 'WS$', name: 'Tala Samoano' },
  { code: 'XAF', symbol: 'FCFA', name: 'Franco CFA de África Central' },
  { code: 'XCD', symbol: 'EC$', name: 'Dólar del Caribe Oriental' },
  { code: 'XOF', symbol: 'CFA', name: 'Franco CFA de África Occidental' },
  { code: 'XPF', symbol: '₣', name: 'Franco CFP' },
  { code: 'YER', symbol: '﷼', name: 'Rial Yemení' },
  { code: 'ZAR', symbol: 'R', name: 'Rand Sudafricano' },
  { code: 'ZMW', symbol: 'ZK', name: 'Kwacha Zambiano' },
  { code: 'ZWL', symbol: 'Z$', name: 'Dólar Zimbabuense' }
];

// Meses
const meses = [
  { value: '01', label: 'Enero' },
  { value: '02', label: 'Febrero' },
  { value: '03', label: 'Marzo' },
  { value: '04', label: 'Abril' },
  { value: '05', label: 'Mayo' },
  { value: '06', label: 'Junio' },
  { value: '07', label: 'Julio' },
  { value: '08', label: 'Agosto' },
  { value: '09', label: 'Septiembre' },
  { value: '10', label: 'Octubre' },
  { value: '11', label: 'Noviembre' },
  { value: '12', label: 'Diciembre' }
];


// Años para selector
const currentYear = new Date().getFullYear();
const años = Array.from({ length: currentYear - 2019 + 1 }, (_, i) => (2020 + i).toString());

const FinanzasPage = () => {
  const theme = useTheme();
  const { user } = useAuth();
  const [transacciones, setTransacciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [tipoTransaccion, setTipoTransaccion] = useState('ingreso');
  const [descripcion, setDescripcion] = useState('');
  const [monto, setMonto] = useState('');
  const [categoria, setCategoria] = useState('');
  const todayLocalISO = () => {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };
  const [fecha, setFecha] = useState(todayLocalISO());  
  const [pacientes, setPacientes] = useState([]);
  const [selectedPaciente, setSelectedPaciente] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState(() => localStorage.getItem('preferredCurrency') || 'HNL');
  const [currencySymbol, setCurrencySymbol] = useState('L');
  const [editingTransaction, setEditingTransaction] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const { selectedClinicId } = useClinic();
  if (selectedClinicId) {
    return <ClinicFinanzasPage />;
  }

  // Filtros
  const [filtroMes, setFiltroMes] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  });
  const [aplicarFiltroMes, setAplicarFiltroMes] = useState(false);
  const [filtroTipo, setFiltroTipo] = useState('todos'); // 'todos', 'ingreso', 'gasto'

  const [transaccionesFiltradas, setTransaccionesFiltradas] = useState([]);
  
  const [yearSelected, setYearSelected] = useState(() => {
    return filtroMes ? filtroMes.split('-')[0] : new Date().getFullYear().toString();
  });

  const [monthSelected, setMonthSelected] = useState(() => {
    return filtroMes ? filtroMes.split('-')[1] : (new Date().getMonth() + 1).toString().padStart(2, '0');
  });

  const [nombreMedico, setNombreMedico] = useState('');

  useEffect(() => {
    if (user && user.medico) {
      const nombreFormateado = `Dr. ${user.first_name || ''} ${user.last_name || ''}`.trim();
      setNombreMedico(nombreFormateado);
    }
  }, [user]);

  const formatNumber = (number) => {
    const num = typeof number === 'string' ? parseFloat(number) : number;
    return new Intl.NumberFormat('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true 
    }).format(num);
  };

  useEffect(() => {
    localStorage.setItem('preferredCurrency', selectedCurrency);
    const currency = currencies.find(c => c.code === selectedCurrency);
    if (currency) {
      setCurrencySymbol(currency.symbol);
      localStorage.setItem('currencySymbol', currency.symbol);
    }
  }, [selectedCurrency]);

  // Filtro: mes (opcional) y tipo (siempre)
  useEffect(() => {
    let filtered = [...transacciones];

    if (aplicarFiltroMes && filtroMes) {
      const [year, month] = filtroMes.split('-');
      filtered = filtered.filter(t => {
        const [y, m] = String(t.fecha).split('-');
        return parseInt(y) === parseInt(year) && parseInt(m) === parseInt(month);
      });
    }

    if (filtroTipo !== 'todos') {
      filtered = filtered.filter(t => t.tipo === filtroTipo);
    }

    setTransaccionesFiltradas(filtered);
  }, [transacciones, filtroMes, aplicarFiltroMes, filtroTipo]);

  // Helper robusto para traer todas las páginas
  const fetchAllPaginated = async (path, signal) => {
    const all = [];
    let url = path;
    while (url) {
      const { data } = await axiosInstance.get(url, { signal });
      const results = data.results || data;
      if (Array.isArray(results)) {
        all.push(...results);
      }
      if (data.next) {
        try {
          const nextUrl = new URL(
            data.next,
            axiosInstance.defaults.baseURL || window.location.origin
          );
          let rel = nextUrl.pathname + nextUrl.search;
          if (rel.startsWith('/api/')) rel = rel.slice(4); // quitar /api para usar con axiosInstance
          url = rel;
        } catch {
          url = null;
        }
      } else {
        url = null;
      }
    }
    return all;
  };

  // Carga inicial con AbortController
  useEffect(() => {
    const ctrl = new AbortController();
    (async () => {
      setLoading(true);
      try {
        const [txs, pacs] = await Promise.all([
          fetchAllPaginated(`/transacciones/?t=${Date.now()}`, ctrl.signal),
          fetchAllPaginated(`/pacientes/?page_size=500&t=${Date.now()}`, ctrl.signal),
        ]);
        setTransacciones(txs);
        setPacientes(pacs);
      } catch (e) {
        if (e?.name === 'CanceledError' || e?.code === 'ERR_CANCELED') return;
        if (e?.response?.status === 401) {
          toast.error('Sesión expirada. Inicia sesión nuevamente.');
        } else {
          toast.error('Error al cargar datos.');
        }
      } finally {
        setLoading(false);
      }
    })();
    return () => ctrl.abort();
  }, []);

  // Refresco de transacciones tras crear/editar/eliminar
  const fetchTransacciones = async () => {
    try {
      const txs = await fetchAllPaginated(`/transacciones/?t=${Date.now()}`);
      setTransacciones(txs);
    } catch (e) {
      if (e?.response?.status === 401) {
        toast.error('Sesión expirada. Inicia sesión nuevamente.');
      } else {
        toast.error("No se pudieron cargar las transacciones.");
      }
    }
  };

  useEffect(() => {
    if (categoria !== 'Consulta') setSelectedPaciente(null);
  }, [categoria]);

  const categoriasGastos = ['Renta del consultorio', 'Implementos médicos', 'Material de oficina', 'Servicios (luz, agua, internet)', 'Mantenimiento', 'Otros gastos'];
  const categoriasIngresos = ['Consulta', 'Procedimientos', 'Emergencias', 'Seguros médicos', 'Otros ingresos'];

  // Totales SIEMPRE basados en transaccionesFiltradas (respetan los filtros activos)
  const calcularTotales = () => {
    const source = transaccionesFiltradas;
    const ingresos = source.filter(t => t.tipo === 'ingreso').reduce((sum, t) => sum + parseFloat(t.monto || 0), 0);
    const gastos = source.filter(t => t.tipo === 'gasto').reduce((sum, t) => sum + parseFloat(t.monto || 0), 0);
    return { ingresos, gastos, balance: ingresos - gastos };
  };

  const handleMonthChange = (event) => {
    const newMonth = event.target.value;
    setMonthSelected(newMonth);
    setFiltroMes(`${yearSelected}-${newMonth}`);
  };

  const handleYearChange = (event) => {
    const newYear = event.target.value;
    setYearSelected(newYear);
    setFiltroMes(`${newYear}-${monthSelected}`);
  };

  const agregarTransaccion = (e) => {
    e.preventDefault();
    let finalDescription = descripcion;
    if (categoria === 'Consulta' && selectedPaciente) {
      finalDescription = `Consulta: ${selectedPaciente.nombres} ${selectedPaciente.apellidos}. ${descripcion}`;
    }
    const nuevaTransaccion = { tipo: tipoTransaccion, descripcion: finalDescription, monto: parseFloat(monto), categoria, fecha };
    
    axiosInstance.post('/transacciones/', nuevaTransaccion)
      .then(() => {
        toast.success("Transacción guardada correctamente.");
        fetchTransacciones();
        setDescripcion(''); setMonto(''); setCategoria('');
        setSelectedPaciente(null); setMostrarFormulario(false);
      })
      .catch(() => toast.error("No se pudo guardar la transacción."));
  };

  const handleEdit = (transaction) => {
    setEditingTransaction(transaction);
    setTipoTransaccion(transaction.tipo);
    setDescripcion(transaction.descripcion);
    setMonto(transaction.monto.toString());
    setCategoria(transaction.categoria);
    setFecha(transaction.fecha);
    
    if (transaction.categoria === 'Consulta' && transaction.descripcion.startsWith('Consulta:')) {
      const pacienteName = transaction.descripcion.split('.')[0].replace('Consulta:', '').trim();
      const foundPaciente = pacientes.find(p => 
        `${p.nombres} ${p.apellidos}`.includes(pacienteName)
      );
      if (foundPaciente) {
        setSelectedPaciente(foundPaciente);
      }
    }
    
    setEditDialogOpen(true);
  };

  const saveEditedTransaction = () => {
    let finalDescription = descripcion;
    if (categoria === 'Consulta' && selectedPaciente) {
      const descPart = descripcion.includes('.') ? 
        descripcion.split('.').slice(1).join('.').trim() : 
        descripcion;
      
      finalDescription = `Consulta: ${selectedPaciente.nombres} ${selectedPaciente.apellidos}. ${descPart}`;
    }
    
    const updatedTransaction = {
      ...editingTransaction,
      tipo: tipoTransaccion,
      descripcion: finalDescription,
      monto: parseFloat(monto),
      categoria,
      fecha
    };
    
    axiosInstance.put(`/transacciones/${editingTransaction.id}/`, updatedTransaction)
      .then(() => {
        toast.success("Transacción actualizada correctamente.");
        fetchTransacciones();
        setEditDialogOpen(false);
        resetForm();
      })
      .catch(() => toast.error("No se pudo actualizar la transacción."));
  };

  const resetForm = () => {
    setTipoTransaccion('ingreso');
    setDescripcion('');
    setMonto('');
    setCategoria('');
    setSelectedPaciente(null);
    setFecha(new Date().toISOString().split('T')[0]);
    setEditingTransaction(null);
  };

  const handleDelete = (id) => {
    if (window.confirm("¿Estás seguro de que quieres eliminar esta transacción?")) {
      axiosInstance.delete(`/transacciones/${id}/`)
        .then(() => {
          toast.success("Transacción eliminada.");
          fetchTransacciones();
        })
        .catch(() => toast.error("No se pudo eliminar la transacción."));
    }
  };

  const generarPDF = async () => {
    const doc = new jsPDF();
    
    // Título y encabezado
    doc.setFontSize(18);
    doc.text('Reporte Financiero', 105, 20, { align: 'center' });
    
    // Información del médico y fecha
    doc.setFontSize(12);
    doc.text(`Médico: ${nombreMedico}`, 20, 30);
    
    // Período del reporte
    let periodoTexto = 'Período: Completo';
    if (aplicarFiltroMes) {
      const mesNombre = meses.find(m => m.value === monthSelected)?.label || '';
      periodoTexto = `Período: ${mesNombre} ${yearSelected}`;
    }
    doc.text(periodoTexto, 20, 40);
    
    // Resumen financiero (basado en transaccionesFiltradas)
    const { ingresos, gastos, balance } = calcularTotales();
    doc.setFontSize(14);
    doc.text('Resumen Financiero', 20, 55);
    doc.setFontSize(12);
    doc.text(`Ingresos totales: ${currencySymbol}${formatNumber(ingresos)}`, 30, 65);
    doc.text(`Gastos totales: ${currencySymbol}${formatNumber(gastos)}`, 30, 75);
    doc.text(`Balance: ${currencySymbol}${formatNumber(balance)}`, 30, 85);
    
    // Tabla de transacciones (respetando filtros aplicados)
    const tableColumn = ["Fecha", "Tipo", "Categoría", "Descripción", "Monto"];
    const tableRows = [];
    
    const transaccionesParaReporte = transaccionesFiltradas;
    
    transaccionesParaReporte.forEach(item => {
      const [y, m, d] = String(item.fecha).split('-');
      const fecha = `${d}/${m}/${y}`;
      const tipo = item.tipo === 'ingreso' ? 'Ingreso' : 'Gasto';
      const monto = `${currencySymbol}${formatNumber(item.monto)}`;
      
      tableRows.push([
        fecha,
        tipo,
        item.categoria,
        item.descripcion,
        monto
      ]);
    });
    
    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 95,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255 },
      alternateRowStyles: { fillColor: [245, 245, 245] },
      columnStyles: {
        0: { cellWidth: 25 },
        1: { cellWidth: 20 },
        2: { cellWidth: 35 },
        3: { cellWidth: 'auto' },
        4: { cellWidth: 30, halign: 'right' }
      }
    });
    
    // Pie de página
    const pageCount = doc.internal.getNumberOfPages();
    for(let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(10);
      doc.text(`Generado con Medify Healthcare - Página ${i} de ${pageCount}`, 105, doc.internal.pageSize.height - 10, { align: 'center' });
    }
    
    // Guardar el PDF
    doc.save(`Reporte_Financiero_${aplicarFiltroMes ? filtroMes : 'Completo'}.pdf`);
  };

  const { ingresos, gastos, balance } = calcularTotales();

  const renderTransactionForm = (isEditing = false) => (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth>
          <InputLabel>Tipo de Transacción</InputLabel>
          <Select
            value={tipoTransaccion}
            label="Tipo de Transacción"
            onChange={(e) => {
              setTipoTransaccion(e.target.value);
              setCategoria(''); // Resetear categoría al cambiar tipo
            }}
            sx={{ borderRadius: '12px' }}
          >
            <MenuItem value="ingreso">Ingreso</MenuItem>
            <MenuItem value="gasto">Gasto</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth>
          <InputLabel>Categoría</InputLabel>
          <Select
            value={categoria}
            label="Categoría"
            onChange={(e) => setCategoria(e.target.value)}
            sx={{ borderRadius: '12px' }}
          >
            {tipoTransaccion === 'ingreso' ? (
              categoriasIngresos.map(cat => (
                <MenuItem key={cat} value={cat}>{cat}</MenuItem>
              ))
            ) : (
              categoriasGastos.map(cat => (
                <MenuItem key={cat} value={cat}>{cat}</MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      </Grid>
      
      {categoria === 'Consulta' && (
        <Grid item xs={12}>
          <Autocomplete
            options={pacientes}
            getOptionLabel={(option) => `${option.nombres} ${option.apellidos}`}
            value={selectedPaciente}
            onChange={(event, newValue) => setSelectedPaciente(newValue)}
            renderInput={(params) => <TextField {...params} label="Seleccionar Paciente" sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }} />}
            renderOption={(props, option) => {
              const { key, ...otherProps } = props;
              return (
                <MenuItem
                  key={option.id_paciente || key}
                  {...otherProps}
                  sx={{
                    py: 1.5,
                    borderRadius: 1,
                    '&:hover': {
                      bgcolor: alpha(theme.palette.primary.main, 0.1)
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    <Typography variant="body1" fontWeight="medium">
                      {`${option.nombres} ${option.apellidos}`}
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
                      <Typography variant="caption" color="text.secondary">
                        {option.email || 'Sin correo'}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {option.telefono_principal || 'Sin teléfono'}
                      </Typography>
                    </Box>
                  </Box>
                </MenuItem>
              );
            }}
            ListboxProps={{
              style: { 
                maxHeight: '300px',
                padding: '8px'
              }
            }}
            popupIcon={<ExpandMoreIcon />}
            noOptionsText="No se encontraron pacientes"
            loadingText="Cargando pacientes..."
          />
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, ml: 1 }}>
            Seleccione un paciente para asociar esta transacción a su historial
          </Typography>
        </Grid>
      )}
      
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Descripción"
          value={descripcion}
          onChange={(e) => setDescripcion(e.target.value)}
          multiline
          rows={3}
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />
      </Grid>
      
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Monto"
          type="number"
          value={monto}
          onChange={(e) => setMonto(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {currencySymbol}
              </InputAdornment>
            ),
          }}
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />
      </Grid>
      
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Fecha"
          type="date"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />
      </Grid>
    </Grid>
  );

  const MotionPaper = motion(Paper);

  return (
    <Container 
      maxWidth={false} 
      sx={{ 
        py: 4,
        px: { xs: 2, sm: 3, md: 4 }, 
        maxWidth: '100%',
        }}>
       <MotionPaper
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        elevation={0}
        sx={{
          position: 'relative',
          overflow: 'hidden',
          borderRadius: 4,
          mb: 3,
          mx: { xs: 2, md: 3 },
          px: { xs: 3, md: 5 },
          py: { xs: 3, md: 4 },
          background: theme => `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          color: 'white',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: -50,
            right: -50,
            width: 200,
            height: 200,
            borderRadius: '50%',
            background: theme => alpha('#fff', 0.1),
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            bottom: -30,
            left: -30,
            width: 150,
            height: 150,
            borderRadius: '50%',
            background: theme => alpha('#fff', 0.08),
          }}
        />
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" sx={{ position: 'relative', zIndex: 1 }}>
          <Box
            sx={{
              bgcolor: theme => alpha('#fff', 0.2),
              color: 'white',
              borderRadius: '50%',
              width: 60,
              height: 60,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: theme => `0 8px 32px ${alpha('#000', 0.2)}`,
            }}
          >
            <MoneyIcon sx={{ fontSize: 34 }} />
          </Box>
          <Box sx={{ flex: 1, textAlign: { xs: 'center', sm: 'left' } }}>
            <Typography variant="h4" sx={{ fontWeight: 800, textShadow: '0 2px 10px rgba(0,0,0,0.25)' }}>
              Control de Finanzas
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              Gestiona ingresos, gastos y genera reportes
            </Typography>
          </Box>
          <Tooltip title="Registrar una nueva transacción">
            <span>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => setMostrarFormulario(true)}
                sx={{
                  bgcolor: 'white',
                  color: 'primary.main',
                  fontWeight: 'bold',
                  borderRadius: 3,
                  px: 3,
                  py: 1.2,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                  '&:hover': { bgcolor: 'grey.100', transform: 'translateY(-2px)', boxShadow: '0 6px 25px rgba(0,0,0,0.2)' },
                  transition: 'all 0.25s ease',
                }}
              >
                Nueva Transacción
              </Button>
            </span>
          </Tooltip>
        </Stack>
        </MotionPaper>    
    

      <Grid container spacing={theme.spacing(3)} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ height: '100%', boxShadow: 3, borderRadius: 4 }}>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <TrendingUpIcon sx={{ fontSize: 32, color: 'success.main', mr: 1 }} />
                <Typography variant="h6" component="h2">Ingresos Totales</Typography>
              </Box>
              <Typography variant="h4" component="p" sx={{ fontWeight: 'bold', color: 'success.main' }}>
                {currencySymbol}{formatNumber(ingresos)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ height: '100%', boxShadow: 3, borderRadius: 4 }}>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <TrendingDownIcon sx={{ fontSize: 32, color: 'error.main', mr: 1 }} />
                <Typography variant="h6" component="h2">Gastos Totales</Typography>
              </Box>
              <Typography variant="h4" component="p" sx={{ fontWeight: 'bold', color: 'error.main' }}>
                {currencySymbol}{formatNumber(gastos)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%', boxShadow: 3, borderRadius: 4 }}>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <MoneyIcon sx={{ fontSize: 32, color: balance >= 0 ? 'success.main' : 'error.main', mr: 1 }} />
                <Typography variant="h6" component="h2">Balance</Typography>
              </Box>
              <Typography 
                variant="h4" 
                component="p" 
                sx={{ 
                  fontWeight: 'bold', 
                  color: balance >= 0 ? 'success.main' : 'error.main' 
                }}
              >
                {currencySymbol}{formatNumber(balance)}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

     

      {/* BARRA DE FILTROS ACTUALIZADA */}
      <Box sx={{ mb: 4, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
        <Button 
          variant="contained" 
          startIcon={<AddIcon />} 
          onClick={() => setMostrarFormulario(true)}
          sx={{ borderRadius: '20px', px: 3 }}
        >
          Nueva Transacción
        </Button>

        <FormControl size="small" sx={{ minWidth: 220 }}>
          <InputLabel>Moneda</InputLabel>
          <Select
            value={selectedCurrency}
            label="Moneda"
            onChange={(e) => setSelectedCurrency(e.target.value)}
            sx={{ borderRadius: '12px' }}
            MenuProps={{ PaperProps: { sx: { maxHeight: 360 } } }}
          >
            {currencies.map((c) => (
              <MenuItem key={c.code} value={c.code}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="body2" sx={{ minWidth: 54 }}>
                    {c.symbol}
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {c.code}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    — {c.name}
                  </Typography>
                </Box>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        
        {/* FILTRO POR TIPO */}
        <ToggleButtonGroup
          color="primary"
          value={filtroTipo}
          exclusive
          onChange={(event, newFilter) => {
            if (newFilter !== null) {
              setFiltroTipo(newFilter);
            }
          }}
          aria-label="filtro tipo de transacción"
          size="small"
          sx={{ '& .MuiToggleButton-root': { borderRadius: '16px', mx: 0.5 } }}
        >
          <ToggleButton value="todos">Todos</ToggleButton>
          <ToggleButton value="ingreso">Ingresos</ToggleButton>
          <ToggleButton value="gasto">Gastos</ToggleButton>
        </ToggleButtonGroup>

        <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 250 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>Mes para reporte</Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel>Mes</InputLabel>
              <Select
                value={monthSelected}
                label="Mes"
                onChange={handleMonthChange}
                sx={{ borderRadius: '12px' }}
              >
                {meses.map(mes => (
                  <MenuItem key={mes.value} value={mes.value}>{mes.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            
            <FormControl size="small" sx={{ minWidth: 100 }}>
              <InputLabel>Año</InputLabel>
              <Select
                value={yearSelected}
                label="Año"
                onChange={handleYearChange}
                sx={{ borderRadius: '12px' }}
              >
                {años.map(año => (
                  <MenuItem key={año} value={año}>{año}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
        
        <FormControlLabel
          control={
            <Switch
              checked={aplicarFiltroMes}
              onChange={(e) => setAplicarFiltroMes(e.target.checked)}
            />
          }
          label="Aplicar filtro por mes"
        />
        
        <Button 
          variant="tonal" 
          startIcon={<DownloadIcon />} 
          onClick={generarPDF}
          sx={{ borderRadius: '20px', px: 3 }}
        >
          Descargar PDF
        </Button>
      </Box>

      {/* Diálogo para agregar nueva transacción - Versión Material 3 Mejorada */}
      <Dialog 
        open={mostrarFormulario} 
        onClose={() => setMostrarFormulario(false)} 
        maxWidth="md" 
        fullWidth 
        PaperProps={{
          elevation: 3,
          sx: {
            width: '95%',
            maxWidth: '800px',
            height: 'auto',
            maxHeight: '90vh',
            borderRadius: '28px',
            overflow: 'hidden'
          }
        }}
      >
        <Box 
          sx={{ 
            bgcolor: theme.palette.mode === 'dark' 
              ? alpha(theme.palette.primary.dark, 0.2) 
              : alpha(theme.palette.primary.light, 0.1),
            p: 3,
            position: 'relative'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box 
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 48,
                height: 48,
                borderRadius: '50%',
                bgcolor: theme.palette.mode === 'dark' 
                  ? alpha(theme.palette.primary.main, 0.3) 
                  : alpha(theme.palette.primary.main, 0.1),
                color: theme.palette.primary.main
              }}
            >
              {tipoTransaccion === 'ingreso' 
                ? <TrendingUpIcon fontSize="medium" /> 
                : <TrendingDownIcon fontSize="medium" />
              }
            </Box>
            <Box>
              <Typography variant="h5" fontWeight="bold">
                {tipoTransaccion === 'ingreso' ? 'Nuevo Ingreso' : 'Nuevo Gasto'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Complete los detalles de la transacción
              </Typography>
            </Box>
          </Box>
          <IconButton 
            onClick={() => setMostrarFormulario(false)} 
            sx={{ 
              position: 'absolute', 
              right: 16, 
              top: 16,
              bgcolor: alpha(theme.palette.background.paper, 0.5),
              '&:hover': {
                bgcolor: alpha(theme.palette.background.paper, 0.8),
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <DialogContent 
          sx={{ 
            p: 3, 
            pt: 4,
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }}
        >
          {/* Selector de tipo con toggle buttons */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Tipo de Transacción
            </Typography>
            <ToggleButtonGroup
              value={tipoTransaccion}
              exclusive
              onChange={(e, newValue) => {
                if (newValue) setTipoTransaccion(newValue);
                setCategoria(''); // Resetear categoría al cambiar tipo
              }}
              aria-label="tipo de transacción"
              fullWidth
              sx={{
                '& .MuiToggleButtonGroup-grouped': {
                  border: 0,
                  borderRadius: '16px !important',
                  mx: 0.5,
                  py: 1.5,
                  '&.Mui-selected': {
                    bgcolor: tipoTransaccion === 'ingreso' 
                      ? alpha(theme.palette.success.main, 0.1)
                      : alpha(theme.palette.error.main, 0.1),
                    color: tipoTransaccion === 'ingreso'
                      ? theme.palette.success.main
                      : theme.palette.error.main,
                    '&:hover': {
                      bgcolor: tipoTransaccion === 'ingreso' 
                        ? alpha(theme.palette.success.main, 0.2)
                        : alpha(theme.palette.error.main, 0.2),
                    }
                  }
                }
              }}
            >
              <ToggleButton 
                value="ingreso"
                sx={{ 
                  borderRadius: '16px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  height: '80px'
                }}
              >
                <TrendingUpIcon color={tipoTransaccion === 'ingreso' ? 'success' : 'inherit'} />
                <Typography variant="body2">Ingreso</Typography>
              </ToggleButton>
              <ToggleButton 
                value="gasto"
                sx={{ 
                  borderRadius: '16px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  height: '80px'
                }}
              >
                <TrendingDownIcon color={tipoTransaccion === 'gasto' ? 'error' : 'inherit'} />
                <Typography variant="body2">Gasto</Typography>
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>

          {renderTransactionForm(false)}
        </DialogContent>

        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'flex-end', 
            gap: 2, 
            p: 3, 
            pt: 2,
            bgcolor: theme.palette.mode === 'dark' 
              ? alpha(theme.palette.background.paper, 0.3) 
              : alpha(theme.palette.background.paper, 0.5),
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`
          }}
        >
          <Button 
            onClick={() => setMostrarFormulario(false)} 
            variant="outlined" 
            sx={{ 
              borderRadius: '20px',
              px: 3,
              py: 1
            }}
          >
            Cancelar
          </Button>
          <Button 
            type="submit" 
            variant="contained" 
            onClick={agregarTransaccion} 
            sx={{ 
              borderRadius: '20px',
              px: 3,
              py: 1,
              bgcolor: tipoTransaccion === 'ingreso' 
                ? theme.palette.success.main
                : theme.palette.error.main,
              '&:hover': {
                bgcolor: tipoTransaccion === 'ingreso' 
                  ? theme.palette.success.dark
                  : theme.palette.error.dark,
              }
            }}
            startIcon={tipoTransaccion === 'ingreso' ? <TrendingUpIcon /> : <TrendingDownIcon />}
          >
            {tipoTransaccion === 'ingreso' ? 'Registrar Ingreso' : 'Registrar Gasto'}
          </Button>
        </Box>
      </Dialog>

      {/* Diálogo para editar transacción - Versión Material 3 */}
      <Dialog 
        open={editDialogOpen} 
        onClose={() => setEditDialogOpen(false)} 
        maxWidth="md" 
        fullWidth
        PaperProps={{
          elevation: 3,
          sx: {
            width: '95%',
            maxWidth: '800px',
            height: 'auto',
            maxHeight: '90vh',
            borderRadius: '28px',
            overflow: 'hidden'
          }
        }}
      >
        <Box 
          sx={{ 
            bgcolor: theme.palette.mode === 'dark' 
              ? alpha(theme.palette.primary.dark, 0.2) 
              : alpha(theme.palette.primary.light, 0.1),
            p: 3,
            position: 'relative'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box 
              sx={{ 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 48,
                height: 48,
                borderRadius: '50%',
                bgcolor: theme.palette.mode === 'dark' 
                  ? alpha(theme.palette.primary.main, 0.3) 
                  : alpha(theme.palette.primary.main, 0.1),
                color: tipoTransaccion === 'ingreso' 
                  ? theme.palette.success.main 
                  : theme.palette.error.main
              }}
            >
              {tipoTransaccion === 'ingreso' 
                ? <TrendingUpIcon fontSize="medium" /> 
                : <TrendingDownIcon fontSize="medium" />
              }
            </Box>
            <Box>
              <Typography variant="h5" fontWeight="bold" color={tipoTransaccion === 'ingreso' ? 'success.main' : 'error.main'}>
                Editar {tipoTransaccion === 'ingreso' ? 'Ingreso' : 'Gasto'}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Modifique los detalles de la transacción
              </Typography>
            </Box>
          </Box>
          <IconButton 
            onClick={() => setEditDialogOpen(false)} 
            sx={{ 
              position: 'absolute', 
              right: 16, 
              top: 16,
              bgcolor: alpha(theme.palette.background.paper, 0.5),
              '&:hover': {
                bgcolor: alpha(theme.palette.background.paper, 0.8),
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <DialogContent 
          sx={{ 
            p: 3, 
            pt: 4,
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }}
        >
          {/* Selector de tipo con toggle buttons */}
          <Box sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Tipo de Transacción
            </Typography>
            <ToggleButtonGroup
              value={tipoTransaccion}
              exclusive
              onChange={(e, newValue) => {
                if (newValue) setTipoTransaccion(newValue);
                setCategoria(''); // Resetear categoría al cambiar tipo
              }}
              aria-label="tipo de transacción"
              fullWidth
              sx={{
                '& .MuiToggleButtonGroup-grouped': {
                  border: 0,
                  borderRadius: '16px !important',
                  mx: 0.5,
                  py: 1.5,
                  '&.Mui-selected': {
                    bgcolor: tipoTransaccion === 'ingreso' 
                      ? alpha(theme.palette.success.main, 0.1)
                      : alpha(theme.palette.error.main, 0.1),
                    color: tipoTransaccion === 'ingreso'
                      ? theme.palette.success.main
                      : theme.palette.error.main,
                    '&:hover': {
                      bgcolor: tipoTransaccion === 'ingreso' 
                        ? alpha(theme.palette.success.main, 0.2)
                        : alpha(theme.palette.error.main, 0.2),
                    }
                  }
                }
              }}
            >
              <ToggleButton 
                value="ingreso"
                sx={{ 
                  borderRadius: '16px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  height: '80px'
                }}
              >
                <TrendingUpIcon color={tipoTransaccion === 'ingreso' ? 'success' : 'inherit'} />
                <Typography variant="body2">Ingreso</Typography>
              </ToggleButton>
              <ToggleButton 
                value="gasto"
                sx={{ 
                  borderRadius: '16px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  height: '80px'
                }}
              >
                <TrendingDownIcon color={tipoTransaccion === 'gasto' ? 'error' : 'inherit'} />
                <Typography variant="body2">Gasto</Typography>
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="categoria-label-edit">Categoría</InputLabel>
                <Select
                  labelId="categoria-label-edit"
                  value={categoria}
                  label="Categoría"
                  onChange={(e) => setCategoria(e.target.value)}
                  sx={{ 
                    borderRadius: '16px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: tipoTransaccion === 'ingreso' 
                        ? alpha(theme.palette.success.main, 0.3)
                        : alpha(theme.palette.error.main, 0.3),
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: tipoTransaccion === 'ingreso' 
                        ? alpha(theme.palette.success.main, 0.5)
                        : alpha(theme.palette.error.main, 0.5),
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: tipoTransaccion === 'ingreso' 
                        ? theme.palette.success.main
                        : theme.palette.error.main,
                    }
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <CategoryIcon color="action" />
                    </InputAdornment>
                  }
                >
                  {tipoTransaccion === 'ingreso' ? (
                    categoriasIngresos.map(cat => (
                      <MenuItem key={cat} value={cat}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Box 
                            sx={{ 
                              width: 8, 
                              height: 8, 
                              borderRadius: '50%', 
                              bgcolor: theme.palette.success.main 
                            }} 
                          />
                          {cat}
                        </Box>
                      </MenuItem>
                    ))
                  ) : (
                    categoriasGastos.map(cat => (
                      <MenuItem key={cat} value={cat}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Box 
                            sx={{ 
                              width: 8, 
                              height: 8, 
                              borderRadius: '50%', 
                              bgcolor: theme.palette.error.main 
                            }} 
                          />
                          {cat}
                        </Box>
                      </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
            </Grid>
            
            {/* Selector de pacientes mejorado */}
            {categoria === 'Consulta' && (
              <Grid item xs={12}>
                <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                  Seleccione el paciente para esta consulta
                </Typography>
                <Autocomplete
                  options={pacientes}
                  getOptionLabel={(option) => `${option.nombres} ${option.apellidos}`}
                  value={selectedPaciente}
                  onChange={(event, newValue) => setSelectedPaciente(newValue)}
                  fullWidth
                  renderInput={(params) => (
                    <TextField 
                      {...params} 
                      label="Paciente" 
                      placeholder="Buscar paciente por nombre"
                      sx={{ 
                        '& .MuiOutlinedInput-root': { 
                          borderRadius: '16px',
                          py: 0.5,
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: alpha(theme.palette.primary.main, 0.3),
                          }
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: '1rem'
                        }
                      }} 
                    />
                  )}
                  renderOption={(props, option) => {
                    const { key, ...otherProps } = props;
                    return (
                      <MenuItem 
                        key={option.id_paciente || key}
                        {...otherProps}
                        sx={{ 
                          py: 1.5,
                          borderRadius: 1,
                          '&:hover': {
                            bgcolor: alpha(theme.palette.primary.main, 0.1)
                          }
                        }}
                      >
                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                          <Typography variant="body1" fontWeight="medium">
                            {`${option.nombres} ${option.apellidos}`}
                          </Typography>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
                            <Typography variant="caption" color="text.secondary">
                              {option.email || 'Sin correo'}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              {option.telefono_principal || 'Sin teléfono'}
                            </Typography>
                          </Box>
                        </Box>
                      </MenuItem>
                    );
                  }}
                  ListboxProps={{
                    style: { 
                      maxHeight: '300px',
                      padding: '8px'
                    }
                  }}
                  popupIcon={<ExpandMoreIcon />}
                  noOptionsText="No se encontraron pacientes"
                  loadingText="Cargando pacientes..."
                />
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, ml: 1 }}>
                  Seleccione un paciente para asociar esta transacción a su historial
                </Typography>
              </Grid>
            )}
            
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Descripción"
                value={descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
                multiline
                rows={3}
                placeholder="Añada detalles sobre esta transacción..."
                sx={{ 
                  '& .MuiOutlinedInput-root': { 
                    borderRadius: '16px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: alpha(theme.palette.text.primary, 0.2),
                    }
                  }
                }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Monto"
                type="number"
                value={monto}
                onChange={(e) => setMonto(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  ),
                }}
                sx={{ 
                  '& .MuiOutlinedInput-root': { 
                    borderRadius: '16px',
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: tipoTransaccion === 'ingreso' 
                        ? alpha(theme.palette.success.main, 0.3)
                        : alpha(theme.palette.error.main, 0.3),
                    }
                  }
                }}
              />
            </Grid>
            
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Fecha"
                type="date"
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ 
                  '& .MuiOutlinedInput-root': { 
                    borderRadius: '16px'
                  }
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'between', 
            gap: 2, 
            p: 3, 
            pt: 2,
            bgcolor: theme.palette.mode === 'dark' 
              ? alpha(theme.palette.background.paper, 0.3) 
              : alpha(theme.palette.background.paper, 0.5),
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`
          }}
        >
          <Button 
            onClick={() => {
              setEditDialogOpen(false);
              resetForm();
            }} 
            variant="outlined" 
            sx={{ 
              borderRadius: '20px',
              px: 3,
              py: 1
            }}
            startIcon={<CloseIcon />}
          >
            Cancelar
          </Button>
          <Button 
            variant="contained" 
            onClick={saveEditedTransaction} 
            sx={{ 
              borderRadius: '20px',
              px: 3,
              py: 1,
              bgcolor: tipoTransaccion === 'ingreso' 
                ? theme.palette.success.main
                : theme.palette.error.main,
              '&:hover': {
                bgcolor: tipoTransaccion === 'ingreso' 
                  ? theme.palette.success.dark
                  : theme.palette.error.dark,
              }
            }}
            startIcon={<SaveIcon />}
          >
            Guardar Cambios
          </Button>
        </Box>
      </Dialog>

      <Paper
        sx={{ 
        width: '100%', 
        overflow: 'hidden',
        boxShadow: 2,
        borderRadius: 4
      }}
     >
        <Box sx={{ p: 3 }}>
          <Typography variant="h5" component="h2"
          sx={{ 
            fontWeight: 'bold',
            fontSize: '1.75rem',
            color: theme.palette.primary.main
          }} 
        >
        Historial de Transacciones
        </Typography>
        </Box>
        <TableContainer
          sx={{ maxHeight: 'calc(100vh - 350px)' }}>
          <Table 
          stickyHeader
          size="medium" 
          sx={{ 
            '& .MuiTableCell-root': {
              fontSize: '1.07rem',
            },
            '& .MuiTableCell-head': {
              fontSize: '1.2rem',
              fontWeight: 'bold',
            }
          }}
          >
            <TableHead>
              <TableRow>
                <TableCell sx={{ backgroundColor: theme.palette.background.default }}>Fecha</TableCell>
                <TableCell sx={{ backgroundColor: theme.palette.background.default }}>Tipo</TableCell>
                <TableCell sx={{ backgroundColor: theme.palette.background.default }}>Categoría</TableCell>
                <TableCell sx={{ backgroundColor: theme.palette.background.default }}>Descripción</TableCell>
                <TableCell align="right" sx={{ backgroundColor: theme.palette.background.default }}>Monto</TableCell>
                <TableCell align="right" sx={{ backgroundColor: theme.palette.background.default }}>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transaccionesFiltradas.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 4, color: 'text.secondary', fontSize: '1.1rem' }}>
                    No hay transacciones que coincidan con los filtros seleccionados.
                  </TableCell>
                </TableRow>
              ) : (
                transaccionesFiltradas.map(transaccion => (
                  <TableRow key={transaccion.id} hover>
                    <TableCell>{(() => { const [y, m, d] = String(transaccion.fecha).split('-'); return `${d}/${m}/${y}`; })()}</TableCell>
                    <TableCell>
                      <Chip 
                        label={transaccion.tipo === 'ingreso' ? 'Ingreso' : 'Gasto'} 
                        color={transaccion.tipo === 'ingreso' ? 'success' : 'error'} 
                        size="small"
                        sx={{ borderRadius: '16px' }}
                      />
                    </TableCell>
                    <TableCell>{transaccion.categoria}</TableCell>
                                        <TableCell>{transaccion.descripcion}</TableCell>
                    <TableCell
                      align="right"
                      sx={{
                        fontWeight: 'medium',
                        color: transaccion.tipo === 'ingreso' ? 'success.main' : 'error.main'
                      }}
                    >
                      {currencySymbol}{formatNumber(parseFloat(transaccion.monto))}
                    </TableCell>
                    <TableCell align="right">
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <IconButton
                          size="small"
                          onClick={() => handleEdit(transaccion)}
                          sx={{ mr: 1 }}
                        >
                          <EditIcon fontSize="small" color="primary" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleDelete(transaccion.id)}
                        >
                          <DeleteIcon fontSize="small" color="error" />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Container>
  );
};

export default FinanzasPage;

